import React from 'react';

export const FontStyleBold = () => (
    <path transform='scale(.92) translate(1, 1)' strokeWidth='2' stroke='currentColor' d='M16.008,11.184C17.794,10.144,19,8.212,19,6c0-3.309-2.691-6-6-6H3.5C3.224,0,3,0.224,3,0.5S3.224,1,3.5,1H6v22H3.5
		C3.224,23,3,23.224,3,23.5S3.224,24,3.5,24h11c3.584,0,6.5-2.916,6.5-6.5C21,14.436,18.865,11.866,16.008,11.184z M13,1
		c2.757,0,5,2.243,5,5s-2.243,5-5,5H7V1H13z M14.5,23H7V12h6h1.5c3.032,0,5.5,2.468,5.5,5.5S17.532,23,14.5,23z' />
);
